module.exports = __webpack_public_path__ + "5b77c55fc63d7862e1d5a1da46729f72.pdf";